import React, { Component } from 'react';
import { connect } from 'react-redux';

import CarouselItem from './carousel-item';
import CarouselRender from './carousel-render';

import './style.css';

class PpcCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isScrolled: false,
      data: []
    };
  }

  renderItems = () => {
    const { isScrolled } = this.state;

    this.setState({
      data: this.props.ppcArticles.map((article, index) => (
        <CarouselItem
          key={index}
          image={article.attributes.link.image}
          id={article.id}
          name={article.attributes.title}
          isScrolled={isScrolled}
        />
      ))
    });
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.ppcArticles !== this.props.ppcArticles &&
      Array.isArray(this.props.ppcArticles) &&
      !!this.props.ppcArticles.length) {
      this.renderItems();
    }
  }

  componentDidMount = () => {
    this.renderItems();
  }

  handleOnClick = () => {
    const { isScrolled } = this.state;

    this.setState({ isScrolled: !isScrolled }, () => {
      this.renderItems();
    });
  }

  render() {
    const { loading } = this.props;
    const { data } = this.state;

    return (
      <CarouselRender
        loading={loading}
        data={data}
        title='Opportunities to earn'
        onClick={this.handleOnClick}
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.latestNews.fetching,
  ppcArticles: state.latestNews.latestNews.filter(article =>
    article.attributes.category.name === 'OPPORTUNITIES TO EARN')
});

export default connect(mapStateToProps)(PpcCarousel);



// WEBPACK FOOTER //
// ./src/components/common/home/carousels/ppc-carousel.jsx